// Traduções dos tipos de eventos para português
export const EVENT_TYPES = {
  PVP: 'PvP',
  BC: 'BC',
  MEETING: 'Reunião',
  OTHER: 'Outro',
};

// Função para obter a tradução do tipo de evento
export const getEventTypeTranslation = (type) => {
  return EVENT_TYPES[type] || type;
};

// Ícones dos tipos de evento
export const getEventTypeIcon = (type) => {
  const typeIcons = {
    PVP: '🗡️',
    BC: '🏰',
    MEETING: '👥',
    OTHER: '🎯'
  };
  return typeIcons[type] || '📦';
};

export const getEventParticipationStatusText = (status) => {
  const texts = {
    CONFIRMED: 'Confirmado',
    DECLINED: 'Recusado',
    PENDING: 'Pendente',
    PROOF_SUBMITTED: 'Prova Enviada',
    PROOF_REJECTED: 'Prova Rejeitada',
    PROOF_APPROVED: 'Prova Aceita',
    POINTS_AWARDED: 'Pontos Creditados',
    AWAITING_EVIDENCE: 'Aguardando prova de participação',
    CHARACTER_LENT: 'Personagem Emprestado',
  };
  return texts[status] || status;
};

export const getEventParticipationStatusBadge = (status) => {
  const variants = {
    PENDING: 'warning',
    CONFIRMED: 'info',
    DECLINED: 'danger',
    PROOF_SUBMITTED: 'warning',
    PROOF_APPROVED: 'success',
    PROOF_REJECTED: 'danger',
    POINTS_AWARDED: 'success',
    AWAITING_EVIDENCE: 'info'
  };
  return variants[status] || 'default';
};

export const getEventStatusText = (status) => {
  const variants = {
    SCHEDULED: 'Agendado',
    ACTIVE: 'Ativo',
    COMPLETED: 'Concluído',
    CANCELLED: 'Cancelado',
  };
  return variants[status] || variants.CANCELLED;
};
